import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';
import { CODE_ERRORS, ENDPOINT_API_PATH } from '../Definitions/AccountIssueDef';

const autoGenerateSuccess = (type: string, value: string) => {
  const bodyRequest =
    type === 'MEMBER'
      ? {
          memberNumber: value,
        }
      : {
          document: {
            type,
            value,
          },
        };

  const validateDocumentSuccess: IMockProps = {
    doc: {
      code: 'Solicitação efetuada com sucesso',
      message: 'Solicitação efetuada com sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        ...bodyRequest,
        name: MocksDef.NAME,
        email: MocksDef.EMAIL,
        phoneList: [
          {
            type: 'CELLULAR',
            internationalCode: MocksDef.PHONE_DDI,
            areaCode: MocksDef.PHONE_DDD,
            number: MocksDef.PHONE_NUMBER,
          },
        ],
        attachment: MocksDef.ATTACHMENTS,
      },
    },
    configResponse: {
      status: 200,
      data: {
        serviceRequestId: '1-128182633147',
        message: 'Solicitação efetuada com sucesso.',
      },
      headers: {},
    },
  };
  return validateDocumentSuccess;
};

const autoGenerateSuccessToken = () => {
  const responseCPF = autoGenerateSuccess('CPF', MocksDef.DOCUMENT_TYPE.CPF);
  const responseMEMBER = autoGenerateSuccess('MEMBER', MocksDef.MEMBER_NUMBER);
  return [responseCPF, responseMEMBER];
};

const generatedSuccessMocks = autoGenerateSuccessToken();

const autoGenerate = (type: string, value: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const bodyRequest =
        type === 'MEMBER'
          ? {
              memberNumber: value,
            }
          : {
              document: {
                type,
                value,
              },
            };

      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body: {
            ...bodyRequest,
            email: `${index}-${MocksDef.EMAIL}`,
            name: MocksDef.NAME,
            phoneList: [
              {
                type: 'CELLULAR',
                internationalCode: MocksDef.PHONE_DDI,
                areaCode: MocksDef.PHONE_DDD,
                number: MocksDef.PHONE_NUMBER,
              },
            ],
            attachment: MocksDef.ATTACHMENTS,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
            metadata: error.metadata,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseCPF = autoGenerate('CPF', MocksDef.DOCUMENT_TYPE.CPF);
  const responseMEMBER = autoGenerate('MEMBER', MocksDef.MEMBER_NUMBER);
  return [...responseCPF, ...responseMEMBER];
};

const errorsGenerated = autoGenerateErrorsMock();

const ValidateDocumentMocks = [...generatedSuccessMocks, ...errorsGenerated];
export default ValidateDocumentMocks;
